import * as WebBrowser from "expo-web-browser";
import { WebBrowserOpenOptions } from "expo-web-browser";
import { navigateToScene } from "../navigation";
import qs from "qs";
import { hideAllModals } from "../../../lib/react-redux-modal-provider";
import { store } from "../../../redux/configureStore";
import { getAuthToken } from "../../../redux/modules/auth/login/selector";
import addHideIntercomButtonToUrl from "../../../lib/addHideIntercomButtonToUrl";
import resolveSignupToWebinarParam from "./resolveSignupToWebinarParam";
import canUseInternalWebBrowser from "./canUseInternalWebBrowser";
import {
  shouldBlockPaymentNavigation,
  showBlockedPaymentModal
} from "./paymentLinkNavigationGuard";

const autoLoginHosts = ["localhost", "squaber.com", "s.squaber.com"];

type OpenBrowserAsyncOptions = WebBrowserOpenOptions & {
  forceWebBrowser?: boolean
};

const openBrowserAsync = async (
  url: string,
  browserParams?: OpenBrowserAsyncOptions
) => {
  const { forceWebBrowser = false, ...expoBrowserParams } = browserParams ?? {};
  let parsedUrl = resolveSignupToWebinarParam(url);

  if (shouldBlockPaymentNavigation(parsedUrl.toString())) {
    showBlockedPaymentModal();
    return;
  }

  const { host } = parsedUrl;

  // Hack: import redux store and take auth token directly from it
  // TODO: Refactor for better approach
  const authToken = getAuthToken(store.getState());

  if (autoLoginHosts.includes(host) && authToken) {
    const parsedQuery = qs.parse(parsedUrl.query, { ignoreQueryPrefix: true });

    parsedQuery["auth_token_for_login"] = authToken;

    parsedUrl.query = qs.stringify(parsedQuery, { addQueryPrefix: true });
  }

  let urlToOpen = parsedUrl.toString();
  if (autoLoginHosts.includes(host)) {
    urlToOpen = addHideIntercomButtonToUrl(urlToOpen);
  }

  if (canUseInternalWebBrowser(parsedUrl, { forceWebBrowser })) {
    hideAllModals();
    return navigateToScene("internalWebBrowser", {
      baseUrl: urlToOpen
    });
  } else {
    try {
      return await WebBrowser.openBrowserAsync(urlToOpen, {
        createTask: false,
        ...(expoBrowserParams ?? {})
      });
    } catch (error) {
      console.error("Failed to open external browser url", urlToOpen, error);
      return null;
    }
  }
};

export default openBrowserAsync;
